// Cognito
export const COGNITO_APPWEBDOMAIN = process.env.REACT_APP_COGNITO_APPWEBDOMAIN || 'upsuite.auth.us-east-2.amazoncognito.com';
export const COGNITO_CLIENTID = process.env.REACT_APP_COGNITO_CLIENTID || '1i0n5la38vre87jr8jkmibdka2';
export const COGNITO_FORGOT_PASSWORD_URL = `https://${COGNITO_APPWEBDOMAIN}/forgotPassword?redirect_uri=${window.location.origin}/login&response_type=code&client_id=${COGNITO_CLIENTID}&scope=openid%20email%20profile`;

// Subscription type
export const shouldRedirect = !process.env.REACT_APP_NO_REDIRECT
export const MARKETPLACE_URL= process.env.REACT_APP_MARKETPLACE_URL || '//upsuite.flexofficepro.com'
export const PRO_URL= process.env.REACT_APP_PRO_URL || '//flexofficepro.com'
